<section>
  <div class="dialog-box">
    <div class="dialog-header">
      <p class="heading">Confirm Specification for Correspondence</p>
      <mat-icon
        aria-hidden="false"
        fontIcon="close"
        class="icon"
        (click)="closeDialog()"
      ></mat-icon>
    </div>

    <div class="dialog-body">
      <div class="flex-box">
        <h3 class="heading">Customer Information</h3>
        <h3 class="heading ml-29">User Information</h3>
      </div>
      <hr class="rule" />

      <div class="form-area" [formGroup]="customerFormGroup">
        <div class="form-box">
          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Name</mat-label>
              <input matInput formControlName="customerName"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationName" class="text-12">
              Customer Name is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Account</mat-label>
              <input matInput formControlName="customerAcc"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationAcc" class="text-12">
              Customer Account is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Phone Number</mat-label>
              <input matInput formControlName="customerPhoneNumber"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationPhoneNumber" class="text-12">
              Customer Phone Number is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Fax Number</mat-label>
              <input matInput formControlName="customerFaxNumber"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationFaxNumber" class="text-12">
              Customer Fax Number is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Fax ATTN</mat-label>
              <input matInput formControlName="customerFaxATTN"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationFaxATTN" class="text-12">
              Customer Fax ATTN is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Customer Email</mat-label>
              <input matInput formControlName="customerEmail"/>
            </mat-form-field>

            <mat-error *ngIf="!customerValidationEmail" class="text-12">
              Customer Email is required input.
            </mat-error>
          </div>
        </div>

        <div class="form-box">
          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>User Name</mat-label>
              <input matInput formControlName="userName"/>
            </mat-form-field>

            <mat-error *ngIf="!userValidationName" class="text-12">
              User Name is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>User Phone Number</mat-label>
              <input matInput formControlName="userPhoneNumber"/>
            </mat-form-field>

            <mat-error *ngIf="!userValidationPhoneNumber" class="text-12">
              User Phone Number is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>User Email</mat-label>
              <input matInput formControlName="userName"/>
            </mat-form-field>

            <mat-error *ngIf="!userValidationEmail" class="text-12">
              User Email is required input.
            </mat-error>
          </div>

          <div class="advance-option-field">
            <mat-form-field appearance="outline" class="text-field">
              <mat-label>Subject</mat-label>
              <input matInput formControlName="subject"/>
            </mat-form-field>

            <mat-error *ngIf="!subjectValidation" class="text-12">
              Subject is required input.
            </mat-error>
          </div>

          <div class="radio-group-box">
            <mat-radio-group aria-label="Select an option" formControlName="sendOptions">
              <mat-radio-button value="fax" color="primary">Fax</mat-radio-button>
              <mat-radio-button value="email" color="primary">Email</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button class="dialog-footer-btn blue-btn" (click)="submitForm()">Ok</button>
      <button class="dialog-footer-btn white-btn" (click)="closeDialog()">
        Close
      </button>
    </div>
  </div>
</section>
